import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { Button, Container, Box, Typography, Paper } from '@mui/material'
import { startOAuthFlow } from '../services/salesforce'

export default function LoginPage() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    // careerId パラメータがあればlocalStorageに保存
    const careerId = searchParams.get('careerId')
    if (careerId) {
      localStorage.setItem('sf_career_id', careerId)
    }
  }, [searchParams])

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 6, textAlign: 'center', width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom>
            PRシートエディタ
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Salesforceにログインしてください
          </Typography>
          <Button variant="contained" size="large" fullWidth onClick={startOAuthFlow} sx={{ mt: 3 }}>
            Salesforceでログイン
          </Button>
        </Paper>
      </Box>
    </Container>
  )
}
